<template>
  <roles-form
    @submit="addRole"
    @close="onClose"
  />
</template>
<script>
import RolesForm from './Form.vue'

export default {
  name: 'CreateErrorPage',
  components: {
    RolesForm,
  },
  data() {
    return {
      distributionId: null,
    }
  },
  created() {
    this.distributionId = this.$route.params.id
  },
  methods: {
    addRole(query) {
      this.$store
        .dispatch('roles/addRole', query)
        .then(() => {
          this.successToast('Role was added')
          this.onClose()
        })
        .catch(error => {
          this.errorToast(error.response?.data?.errors[0] || 'Something went wrong while creating role.')
        })
    },

    onClose() {
      this.$router.push({ name: 'organization-settings', query: { tab: '2' } })
    },
  },
}
</script>
